import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { PendingItemWithProvider } from "../../../types";
import { keys } from "./keys";
import { _3_DAYS } from "../../../constants/durations";

async function fetchPendingItems(subTopicId: string, state: 'pending' | 'completed' | null) {
  let query = apiClient
    .from('subject_pending_items')
    .select('*, provider:providers(name)')
    .eq('subject_id', subTopicId)
    .order('position', { ascending: true });

  if (state) {
    query = query.eq('state', state);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return data as PendingItemWithProvider[];
}

export function useGetPendingItemsBySubTopicId(subTopicId: string | undefined, state: 'pending' | 'completed' | null) {
  return useQuery({
    queryKey: keys.getPendingItemsFiltered(subTopicId ?? '', state),
    queryFn: () => fetchPendingItems(subTopicId!, state),
    enabled: !!subTopicId,
    staleTime: _3_DAYS
  });
}
